import { Collapse } from "@kunukn/react-collapse";

const NxCollapse = ({ children, isOpen }) => {
  return <Collapse isOpen={isOpen}>{children}</Collapse>;
};

export default NxCollapse;
